import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '../typography/Typography';
import CheckboxButton from './checkboxButton';
import { CheckboxLabel, LabelWrapper } from './style';
export var CheckboxType;
(function (CheckboxType) {
    CheckboxType["SECONDARY"] = "SECONDARY";
    CheckboxType["PRIMARY"] = "PRIMARY";
    CheckboxType["TERTIARY"] = "TERTIARY";
})(CheckboxType || (CheckboxType = {}));
const Checkbox = ({ label, checkboxType = CheckboxType.PRIMARY, checked = false, disabled = false, error, id = 'checkbox', testId = 'input-error', name, onChangeValue, onChange, className, titleType = 'bodyButton', }) => {
    const handleChange = (e) => {
        if (disabled)
            return;
        if (onChange) {
            onChange(e);
        }
        else if (onChangeValue) {
            onChangeValue(e.target.checked);
        }
    };
    return (_jsxs(CheckboxLabel, { "data-cy": testId, hasError: !!error, hasLabel: !!label, className: className, children: [_jsx(CheckboxButton, { hasError: !!error, name: name, testId: testId, id: id, disabled: disabled, onChange: handleChange, checked: checked, checkboxType: checkboxType }), !!label && (_jsx(LabelWrapper, { htmlFor: id, children: typeof label === 'string' ? (_jsx(Typography, { type: titleType, fontFamily: "primaryMedium", children: label })) : (label) }))] }));
};
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map